import { createAction } from "redux-actions";

export const USER_SELECTS_VIEW_TYPE = "USER_SELECTS_VIEW_TYPE";
export const userSelectsViewType = createAction(USER_SELECTS_VIEW_TYPE);
